import { Grid } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledTabPanel = styled('div', { shouldForwardProp: (prop) => prop !== '$visible' })<{
  $visible: boolean;
}>`
  display: ${(props) => (props.$visible ? 'block' : 'none')};
`

export const StyledCategoryTabPanelContainer = styled(Grid)`
  padding-bottom: ${(props) => props.theme.typography.pxToRem(20)};
`

export const StyledCategoryGroup = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => props.theme.typography.pxToRem(10)};
  margin-left: ${(props) => props.theme.typography.pxToRem(20)};
`
